var $e00b505c063926a4$exports = {};
$e00b505c063926a4$exports = {
    "collectionLabel": `\u{5EFA}\u{8BAE}`
};


export {$e00b505c063926a4$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
